import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navbar: {
      transparent: true,
    },
    gallery: {
      albums: [
        // {
        //   id: 'borrelronde12019',
        //   cover: {
        //     alt: '',
        //     src: '/images/albums/borrelronde12019/cover.jpg'
        //   },
        //   title: 'Borrelronde I',
        //   caption: '17-09-2019',
        //   description: 'Borrelronde 1 van de nieuwe lichting \'19',
        //   length: 18
        // },
        // {
        //   id: 'borrelronde22019',
        //   cover: {
        //     alt: '',
        //     src: '/images/albums/borrelronde22019/cover.jpg'
        //   },
        //   title: 'Borrelronde II',
        //   caption: '19-09-2019',
        //   description: 'Borrelronde 2 van de nieuwe lichting \'19',
        //   length: 24
        // },
        {
          id: 'guatamala19',
          cover: {
            src: '/images/albums/guatamala19/cover.jpg',
          },
          translationKey: 'gallery.guatemala',
          length: 9,
        },
        {
          id: 'gala18',
          cover: {
            src: '/images/albums/gala18/cover.jpg',
          },
          translationKey: 'gallery.gala',
          length: 9,
        },
        {
          id: 'burgerdag18',
          cover: {
            src: '/images/albums/burgerdag18/cover.jpg',
          },
          translationKey: 'gallery.burgerdag',
          length: 9,
        },
      ],
    },
  },
  mutations: {
    TOGGLE_ON_NAVBAR_TRANSPARENT(state) {
      state.navbar.transparent = true;
    },

    TOGGLE_OFF_NAVBAR_TRANSPARENT(state) {
      state.navbar.transparent = false;
    },
  },
  actions: {
  },
});
